import { FontIcon } from '../FontIcon';
import { Skeleton } from '../Skeleton';
import styles from './remind.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLAnchorElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    href?: string;
    image?: string; // Optional when loading
    title?: string;
    description?: string;
    when?: string;
    locked?: boolean;
    showBell?: boolean;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    href: string;
    image: string; // Required when not loading
    title: string;
    description?: string;
    when?: string;
    locked?: boolean;
    showBell?: boolean;
}

type RemindItemProps = LoadingProps | LoadedProps;

export const RemindItem = ({
    href,
    image,
    title,
    description,
    when,
    locked,
    showBell,
    isLoading,
    ...props
}: RemindItemProps) => {
    if (isLoading) {
        return (
            <div className={cn(styles.item, props.className, { [styles.loading]: isLoading })}>
                <Skeleton absolute />
            </div>
        );
    }

    return (
        <a
            href={href ?? '#'}
            className={cn(styles.item, props.className)}
            {...props}
            onClick={(e) => {
                if (!href) {
                    e.preventDefault();
                }
            }}
        >
            <div className={styles.image} style={{ backgroundImage: `url(${image})` }}></div>
            <div className={styles.info}>
                <strong className={styles.title}>{title}</strong>
                {description && <div className={styles.description}>{description}</div>}
                {when && <div className={styles.when}>{when}</div>}
            </div>
            {locked && (
                <div className={styles.lock}>
                    <FontIcon name="lock" size="x-small" md="smaller" />
                </div>
            )}
            {showBell && (
                <div className={styles.bell}>
                    <FontIcon name="bell-filled" size="x-small" md="smaller" />
                </div>
            )}
        </a>
    );
};
